module.exports = __webpack_public_path__ + "img/青山.a1554da1.png";